import { render, staticRenderFns } from "./Mannschaft.vue?vue&type=template&id=cff89470&"
import script from "./Mannschaft.vue?vue&type=script&lang=js&"
export * from "./Mannschaft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports